export { default } from "./ThreeGridAltOverflowPattern";
